<template>
  <v-snackbar v-model="show" :color="color" :bottom="true" :multi-line="true">
    <span v-html="message"></span>
    <v-btn text @click.native="show = false">Close</v-btn>
  </v-snackbar>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      color: 'info',
      message: '',
    };
  },
  methods: {
    onToast(message, error, color) {
      if (color) {
        this.color = color;
      }
      if (message !== '') {
        this.message = message;
        this.show = true;
      }
      if (error) {
        // tslint:disable-next-line:no-console
        //console.error(error);
        if (error.response && error.response.data) {
          // tslint:disable-next-line:no-console
          //console.error('Response', error.response.status, error.response.data);
        }
      }
    },
  },
  destroyed() {
    this.$toast.$off('info');
    this.$toast.$off('error');
    this.$toast.$off('warning');
    this.$toast.$off('success');
  },
  created() {
    this.$toast.$on('info', (message, error) => this.onToast(message, error, 'info'));
    this.$toast.$on('error', (message, error) => this.onToast(message, error, 'error'));
    this.$toast.$on('warning', (message, error) => this.onToast(message, error, 'warning'));
    this.$toast.$on('success', (message, error) => this.onToast(message, error, 'success'));
  },
};
</script>
